import {createContext} from 'react';

const ReportSummaryContext = createContext(null);

export default ReportSummaryContext;
